import { Outlet } from "react-router-dom";
import AdminRouteLayout from "../../navigation/AdminRouteLayout";

const CouponsRoot = () => (
  <AdminRouteLayout>
    <Outlet />
  </AdminRouteLayout>
);

export default CouponsRoot;
